import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    text-decoration: none;\n    padding: 0;\n    font-weight: ", ";\n    cursor: pointer;\n    border: none;\n    box-sizing: border-box;\n    display: inline-flex;\n\n    text-decoration: none;\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        text-decoration: none;\n    }\n\n    background-color: transparent;\n    color: ", ";\n    font-size: ", ";\n    &:hover {\n        background: ", ";\n    }\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import { fontSize03, fontWeightMedium } from '../../../tokens';
import { getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { color } from '../../../system/mixins';
var propertyList = {};

var HeaderNavigationTitleRootWrapper = function HeaderNavigationTitleRootWrapper(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["children"]);

  return children(_objectSpread({}, restProps));
};

export var HeaderNavigationTitleRoot = styled(HeaderNavigationTitleRootWrapper).withConfig(getPropsBlocker(propertyList, false))(_templateObject(), fontWeightMedium, color('neutral.06'), fontSize03, color('neutral.02'), getComponentOverride('HeaderNavigationTitle'));